import React from 'react';
import Firebase from 'firebase';

export default class row extends React.Component {
    constructor() {
        super();
        this.state = {
            data: []
        }
    }

    /*    componentWillReceiveProps(nextProps) {
           var data = []
           const contex = this;
           if (nextProps.num_days > (nextProps.day + 1)) {
               var init = new Date(nextProps.year, (nextProps.month - 1), nextProps.day).getTime();
               var end = new Date(nextProps.year, (nextProps.month - 1), (nextProps.day + 1)).getTime();
               var dataRef = Firebase.database().ref(ref);
               dataRef.orderByChild("global/date/device").startAt(init).endAt(end)
                   .on('value', snap => {
                       var data = [];
                       snap.forEach(function (childSnapshot) {
                           if (childSnapshot.val().global.user.rut === contex.props.user.value) {
                               data.push(childSnapshot.val())
                           }
                       });
                       this.setState({ data: data })
                   })
           } else {
               var init = new Date(nextProps.year, (nextProps.month - 1), nextProps.day).getTime();
               var dataRef = Firebase.database().ref(ref);
               dataRef.orderByChild("global/date/device").startAt(init)
                   .on('value', snap => {
                       var data = [];
                       snap.forEach(function (childSnapshot) {
                           if (childSnapshot.val().global.user.rut === contex.props.user.value) {
                               data.push(childSnapshot.val())
                           }
                       });
                       this.setState({ data: data })
                   })
           }
       } */


    componentDidMount() {
        var data = new Array();
        const contex = this;
        var ref = "saved/" + localStorage.client_id + "/" + this.props.form + "/3/raw/data";
        if (this.props.num_days > (this.props.day + 1)) {
            var init = new Date(this.props.year, (this.props.month - 1), this.props.day).getTime();
            var end = new Date(this.props.year, (this.props.month - 1), (this.props.day + 1)).getTime();
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + this.props.form + "/3/raw/data");
            dataRef.orderByChild("global/date/device").startAt(init).endAt(end)
                .on('value', snap => {
                    var data = [];
                    snap.forEach(function (childSnapshot) {
                        if (childSnapshot.val().global.user.rut === contex.props.user.value) {
                            data.push(childSnapshot.val())
                        }
                    });
                    this.setState({ data: data })
                })
        } else {
            var init = new Date(this.props.year, (this.props.month - 1), this.props.day).getTime();
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + this.props.form + "/3/raw/data");
            dataRef.orderByChild("global/date/device").startAt(init)
                .on('value', snap => {
                    var data = [];
                    snap.forEach(function (childSnapshot) {
                        if (childSnapshot.val().global.user.rut === contex.props.user.value) {
                            data.push(childSnapshot.val())
                        }
                    });
                    this.setState({ data: data })
                })
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.data !== this.state.data && nextState.data.length > 0) {
            nextState.data.map((d) => {
                if (d.results.BUTTONGROUP_2 === "check-in") {
                    this.setState({ checkIn: d.global.date.device })
                } else if (d.results.BUTTONGROUP_2 === "check-out") {
                    this.setState({ checkOut: d.global.date.device })
                } else {
                    this.setState({ checkIn: "", checkOut: "" })
                }
            })
        }
    }

    DateToFormattedString(timeStamp) {
        var d = new Date(timeStamp)
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    render() {
        return (
            <td>
                {
                    this.state.checkIn && this.state.checkOut ?
                        <div onClick={() => { this.props.callBack(this.state.data) }}>
                            <div className="small text-muted" style={{ color: "#4dbd74" }}>
                                {this.DateToFormattedString(this.state.checkIn)}
                            </div>
                            <div className="small text-muted" style={{ color: "#eb6651" }}>
                                {this.DateToFormattedString(this.state.checkOut)}
                            </div>
                        </div>
                        :
                        ""
                }
            </td>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/control_de_asistencia/row.js